module.exports = __webpack_public_path__ + "static/media/manage_data.c4f45cf4.png";